<template>
    <div>
        <div class="tw-px-4 tw-py-3 tw-border-2 tw-border-grey-600 tw-border-solid tw-mb-4 tw-mx-0 md:tw-mx-24" style="border-color: #505050; border-bottom-width: 8px">
            <div class="tw-flex tw-flex-row tw-items-center tw-justify-between">
                <h1 class="tw-text-5xl tw-text-secondary" style="text-transform: none;">
                    {{ member.first_name }} {{ member.last_name }}<span v-if="member.designation">, {{ member.designation }}</span>
                </h1>

                <v-btn @click="manageClick()" class="main-btn">Manage</v-btn>
            </div>
            <div>
                <h3 class="tw-text-2xl">{{ member.id }}</h3>
                <h3 class="tw-text-2xl">{{ member.status?.classification_name }}</h3>
                <h3 class="tw-text-2xl">{{ generatePronounsList()  }}</h3>
            </div>
            <div class="tw-flex tw-flex-col md:tw-flex-row">
                <div class="tw-w-1/4"><a :href="`mailto:${member.emails[0]?.email}`">{{ member.emails[0]?.email || 'Email' }}</a></div>
                <div class="tw-w-1/4">{{ member.telephones[0]?.telephone_fax || 'Phone Number' }}</div>
                <div class="tw-w-1/4"><a :href="generateURL(member?.website)" target="_blank">Website</a></div>
                <div class="tw-w-1/4"><a :href="generateURL(member?.demo_reel)" target="_blank">Demo Reel</a></div>
            </div>
        </div>

        <div class="tw-flex tw-flex-col">
            <v-tabs v-model="current_tab" grow active-class="active-tab" slider-size="0" height="35" class="tw-pt-3">
                <v-tab class="tw-border-b-2 tw-border-secondary tw-mr-2">Overview</v-tab>
                <v-tab class="tw-border-b-2 tw-border-secondary tw-mr-2">Categories</v-tab>
                <v-tab class="tw-border-b-2 tw-border-secondary tw-mr-2">Special Skills</v-tab>
                <v-tab class="tw-border-b-2 tw-border-secondary tw-mr-2">Availabilities</v-tab>
                <v-tab class="tw-border-b-2 tw-border-secondary tw-mr-2">Base dues & Fees</v-tab>
                <v-tab class="tw-border-b-2 tw-border-secondary tw-mr-2">RRSP</v-tab>
                <v-tab class="tw-border-b-2 tw-border-secondary tw-mr-2">Health & Welfare</v-tab>
                <v-tab class="tw-border-b-2 tw-border-secondary">Other Fringes</v-tab>

                <v-tab-item class="tw-py-4"><members-show-overview :input="member" :constants="constants" :valuelists="valuelist"/></v-tab-item>
                <v-tab-item class="tw-py-4"><members-show-categories @successful-save="reloadInput" @successful-delete="reloadInput" :input="member" :valuelists="valuelist" /></v-tab-item>
                <v-tab-item class="tw-py-4"><members-show-special-skills :input="member" :valuelists="valuelist"/></v-tab-item>
                <v-tab-item class="tw-py-4"><members-show-availabilities :input="member" :valuelists="valuelist" @successful-save="reloadInput" @successful-delete="reloadInput"/></v-tab-item>
                <v-tab-item class="tw-py-4"><members-show-base-dues :input="member" :valuelists="valuelist"/></v-tab-item>
                <v-tab-item class="tw-py-4"><members-show-r-r-s-p :input="member" :valuelists="valuelist" :constants="constants"/></v-tab-item>
                <v-tab-item class="tw-py-4"><members-show-health-welfare :input="member" :valuelists="valuelist" :constants="constants"/></v-tab-item>
                <v-tab-item class="tw-py-4"><members-show-working-dues :input="member" :valuelists="valuelist" :constants="constants"/></v-tab-item>
            </v-tabs>
        </div>
    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import AppLayout from "@/Layouts/AppLayout.vue";
    import InternalHeader from "@/Generic/InternalHeader";
    import MembersShowOverview from "@/Pages/InternalPages/Members/MembersShowOverview";
    import InternalTableSection from "@/Generic/InternalTableSection";
    import MembersShowSpecialSkills from "@/Pages/InternalPages/Members/MembersShowSpecialSkills";
    import MembersShowCategories from "@/Pages/InternalPages/Members/MembersShowCategories";
    import MembersShowAvailabilities from "@/Pages/InternalPages/Members/MembersShowAvailabilities.vue";
    import MembersShowWorkingDues from "@/Pages/InternalPages/Members/MembersShowWorkingDues.vue";
    import MembersShowRRSP from "@/Pages/InternalPages/Members/MembersShowRRSP.vue";
    import MembersShowHealthWelfare from "@/Pages/InternalPages/Members/MembersShowHealthWelfare.vue";

    import MembersShowBaseDues from "@/Pages/InternalPages/Members/MembersShowBaseDues";

    export default {
        name: "MembersShow",
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        components: {
            MembersShowWorkingDues,
            MembersShowAvailabilities,
            MembersShowSpecialSkills,
            SmartTable,
            InternalHeader,
            MembersShowOverview,
            InternalTableSection,
            MembersShowCategories,
            MembersShowBaseDues,
            MembersShowRRSP,
            MembersShowHealthWelfare,
        },
        remember: {
            data: [
                'items'
            ]
        },
        props: {
            'input': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                search: null,
                member: this.input,
                constant: this.constants,
                valuelist: this.valuelists,
                current_tab: null
            }
        },
        computed: {

        },
        methods: {
            generatePronounsList() {
                let list = this.member.pronouns.map(obj => obj.pronoun)
                let listWithoutDuplicates = [...new Set(list)]
                return listWithoutDuplicates.join('/')
            },
            generateURL(url) {
                if(!url){return false;}

                if (url.includes('//')) {
                    return url
                } else {
                    return '//' + url
                }
            },
            manageClick() {
                this.$inertia.visit(route('members.edit', this.member.id))
            },
            reloadInput() {
                this.$inertia.reload({only: ['input']})
            },
        },
        watch: {
            input(newInput, oldInput) {
                this.member = newInput
            },
        }
    }
</script>

<style scoped>
.active-tab {
    background-color: #ece4df;
    color: #3c47d1 !important;
    font-weight:bold;
}


</style>
